'use client';

import { FloatingPortal } from '@floating-ui/react';
import { useContext } from 'react';

import { TooltipRootContext } from './context/tooltip-root.context';
import type { TooltipPortalPropsInterface } from './types/tooltip-portal.types';

/**
 * @since 10.0.0
 */
export const TooltipPortal = (props: TooltipPortalPropsInterface) => {
  const { tooltip } = useContext(TooltipRootContext);

  if (!tooltip.isMounted) {
    return null;
  }

  return <FloatingPortal {...props} />;
};

TooltipPortal.displayName = 'Tooltip.Portal';
